export function uppercaseFirstletter(selector) {
	$(selector).on("change", function () {
		// Nicht bei Adelsprädikaten großschreiben
		// https://de.wikipedia.org/wiki/Adelspr%C3%A4dikat
		if (
			$(this).val().indexOf("von ") === 0 ||
			$(this).val().indexOf("vor ") === 0 ||
			$(this).val().indexOf("van ") === 0 ||
			$(this).val().indexOf("zu ") === 0 ||
			$(this).val().indexOf("v. ") === 0 ||
			$(this).val().indexOf("vom ") === 0 ||
			$(this).val().indexOf("di ") === 0 ||
			$(this).val().indexOf("del ") === 0 ||
			$(this).val().indexOf("da ") === 0 ||
			$(this).val().indexOf("degli ") === 0 ||
			$(this).val().indexOf("dalla ") === 0 ||
			$(this).val().indexOf("ter ") === 0 ||
			$(this).val().indexOf("de ") === 0
		) {
			return;
		}

		$(this).val($(this).val().charAt(0).toUpperCase() + $(this).val().slice(1));
	});
}
